import { IMetricsDataModel } from '../../../data-models/metrics.data-model';
import { IPortfolioTreeRow } from './computeTreeRows';

/** Dedupe the leaves, not the flat rows: a company sits under several vehicles, but a fund split
 * gives it several flat rows and publishing only the first understates every KPI by the rest. */
export function publishedRowsFromTree(
  visibleRows: readonly (IPortfolioTreeRow | null | undefined)[],
  metricsByCompanyId: ReadonlyMap<number, IMetricsDataModel[]>
): IMetricsDataModel[] {
  const seen = new Set<number>();
  const published: IMetricsDataModel[] = [];

  for (const row of visibleRows) {
    if (row?.treeKind !== 'company' || row.companyId == null || seen.has(row.companyId)) {
      continue;
    }
    seen.add(row.companyId);
    published.push(...(metricsByCompanyId.get(row.companyId) ?? []));
  }

  return published;
}

/** Every flat row a company has, in the order the flat grid holds them. */
export function indexMetricsByCompanyId(
  metrics: readonly IMetricsDataModel[] | undefined
): Map<number, IMetricsDataModel[]> {
  const byCompanyId = new Map<number, IMetricsDataModel[]>();
  for (const metric of metrics ?? []) {
    if (metric.companyId == null) {
      continue;
    }
    const rows = byCompanyId.get(metric.companyId);
    if (rows) {
      rows.push(metric);
    } else {
      byCompanyId.set(metric.companyId, [metric]);
    }
  }
  return byCompanyId;
}
